/**
 * Maximum character limits for form fields.
 * Used across User, Staff, Branch, Department, and Sub Department forms.
 */
export const FIELD_LIMITS = {
  // User form
  FULL_NAME: 100,
  EMPLOYEE_NUMBER: 50,

  // Staff form
  EMPLOYEE_CODE: 50,
  STAFF_NAME: 50, // first_name, middle_name, last_name

  // Branch, Department, Sub Department forms
  BRANCH_NAME: 100,
  DEPARTMENT_NAME: 50,
  SUB_DEPARTMENT_NAME: 50,
};
